<div>
    <form nz-form #commentPage="ngForm">
        <div nz-row class="my-box" nzGutter="5">
            <!-- <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-label nzNoColon>Date Time</nz-form-label>

                    <nz-form-control>
                        <nz-date-picker style="width: 100%;" name="dateTime" nzShowTime [nzShowTime]="{ nzFormat: 'HH:mm' }" nzFormat="dd/MM/yyyy hh:mm a" [(ngModel)]="data.COMMENT_DATETIME"></nz-date-picker>
                    </nz-form-control>
                </nz-form-item>
            </div> -->

            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Comment</nz-form-label>

                    <nz-form-control nzHasFeedback>
                        <textarea nz-input [nzAutosize]="{ minRows: 2, maxRows: 6 }" name="comment"
                            placeHolder="Enter a Comment" [(ngModel)]="data.COMMENT_TEXT" required></textarea>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Tagged User</nz-form-label>

                    <nz-input-group>
                        <nz-select name="taggedUser" nzMode="multiple" nzPlaceHolder="Select Users to Tag"
                            style="width: 100%;" nzShowSearch style="width: 100%" [(ngModel)]="data.TAGGED_USERS">
                            <nz-option *ngFor="let user of taggedUserList" [nzValue]="user.ID" [nzLabel]="user.NAME">
                            </nz-option>
                        </nz-select>
                    </nz-input-group>
                </nz-form-item>
            </div>

            <!-- <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-label nzNoColon>Active</nz-form-label>

                    <nz-form-control>
                        <nz-switch name="isActive" [(ngModel)]="data.IS_ACTIVE"></nz-switch>
                    </nz-form-control>
                </nz-form-item>
            </div> -->

            <!-- <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Type</nz-form-label>

                    <nz-form-control>
                        <input nz-input name="type" type="number" min="0" oninput="this.value = Math.abs(this.value)" onkeyup="if(this.value> 60){this.value= 60}" placeHolder="Enter Seconds" [(ngModel)]="data.TYPE" required/>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Type ID</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Spent Seconds is Required">
                        <input nz-input name="typeID" type="number" min="0" oninput="this.value = Math.abs(this.value)" onkeyup="if(this.value> 60){this.value= 60}" placeHolder="Enter Seconds" [(ngModel)]="data.TYPE_ID" required/>
                    </nz-form-control>
                </nz-form-item>
            </div> -->
        </div>
    </form>
</div>

<div class="footer">
    <button type="button" nz-button class="ant-btn" style="margin-right: 8px;"
        (click)="close(commentPage)"><span>Cancel</span></button>
    <button type="button" class="ant-btn ant-btn-primary" nz-button [nzLoading]="isSpinning" *ngIf="data.ID"
        (click)="save(false, commentPage)"><span>Update & close</span></button>
    <button type="button" class="ant-btn ant-btn-primary" nz-button [nzLoading]="isSpinning" *ngIf="!data.ID"
        (click)="save(false, commentPage)"><span>Post</span></button>
    <!-- <button type="button" nz-button class="ant-btn" style="margin-right: 8px;" (click)="resetDrawer(commentPage)"><span>Reset</span></button> -->
</div>